import React from "react"
import ReactDOM from "react-dom"
import Map from "./map"

export default class PanningMapBlockModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
  }

  init() {
    const self = this

    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<Map {...self.modelJson} />, self.elem)
  }
}
